/// <amd-module name="VSS/Platform/Fallback" />
import * as WebPlatformResources from "VSS/Platform/Resources";
import { ICompletedContent, IVssContentService } from "./Content";
import { IVssPageContext, ServiceOptions, Services, VssService } from "./Context";
import { onClickFPS } from "./FPS";
import { IVssPageService } from "./Page";

const telemetrySource = "cdn.fallback.service";

class VssFallbackService extends VssService {
    private secureFlag = "";
    private usedCdnFallback = false;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);

        const pageDataService = this.pageContext.getService<IVssPageService>("IVssPageService");
        const pageData = pageDataService.getData();

        if (pageData && pageData.isCdnEnabled) {
            if (pageData.isSslOnly) {
                this.secureFlag = ";secure";
            }

            // Register with the content service for stylesheets being loaded.
            const contentService = this.pageContext.getService<IVssContentService>("IVssContentService");
            contentService.subscribe(this.contentLoadError, "contentLoadError");
        }
    }

    private contentLoadError = (completedContent: ICompletedContent): void => {
        if (!this.usedCdnFallback) {
            this.usedCdnFallback = true;
            // If there is an error with the content loaded from the CDN, try to reload
            // current page to get the same content loaded from AT (instead of CDN) as a backup plan.
            //
            // The reason we use FPS is to handle dirty state in a better way, where a custom
            // dialog is displayed (instead of browser dialog which doesn't tell much) with
            // the message we specify.
            //
            // If there is no dirty document, FPS will execute silently.
            const maxAge = 8 * 60 * 60;
            document.cookie = `TFS-CDN=disabled;max-age=${maxAge};path=/${this.secureFlag}`;
            document.cookie = `TFS-CDNTRACE=report-true;path=/${this.secureFlag}`;

            onClickFPS(this.pageContext, window.location.href, false, undefined, {
                telemetrySource,
                telemetryProperties: { failingContent: completedContent },
                customUnloadMessage: WebPlatformResources.CdnFallbackErrorMessage
            });
        }
    };
}

Services.add("IVssFallbacksService", { serviceFactory: VssFallbackService, options: ServiceOptions.Persistant | ServiceOptions.Startup });
